import { render, staticRenderFns } from "./indexR.vue?vue&type=template&id=0c9778f2&"
import script from "./indexR.vue?vue&type=script&lang=js&"
export * from "./indexR.vue?vue&type=script&lang=js&"
import style0 from "./indexR.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports